/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CookieRefreshRequest} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'
import {CookieRefreshResponse} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'


export const cookieRefresh = (request: CookieRefreshRequest, options?: CashRequestOptions) => post<CookieRefreshRequest, CookieRefreshResponse>("/2.0/cash/cookie-refresh", request, {...options, rejectOnError: true })